import React, { useState, useEffect, useMemo } from 'react';
import { Layout, Tabs, Button, Space, Avatar } from 'antd';
import { useLocation, useNavigate, useOutlet } from 'react-router-dom';
import SidebarMenu from './SidebarMenu';
import { routeConfig } from '../../routes';
import { SyncOutlined, UserOutlined } from '@ant-design/icons';
import { matchPath } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const { Header, Sider, Content } = Layout;

const MainLayout = () => {
  const [activeKey, setActiveKey] = useState('');
  const [panes, setPanes] = useState([]);

  const location = useLocation();
  const navigate = useNavigate();
  const outlet = useOutlet();
  const { user, logout } = useAuth();

  useEffect(() => {
    const match = Object.keys(routeConfig).find(path =>
      matchPath({ path, end: true }, location.pathname)
    );

    if (match && outlet) {
      const { title } = routeConfig[match];
      const key = location.pathname;

      setPanes(prevPanes => {
        if (prevPanes.some(pane => pane.key === key)) {
          return prevPanes;
        }
        const newPane = {
          title: match.includes(':id') ? `${title} #${key.split('/').pop().substring(0, 6)}...` : title,
          key: key,
          content: outlet,
          closable: key !== '/dashboard',
          refreshKey: 0,
        };
        return [...prevPanes, newPane];
      });
      setActiveKey(key);
    }
  }, [location, outlet]);

  useEffect(() => {
    if (location.state?.closeCurrent && activeKey) {
      remove(activeKey);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  const onChange = (newActiveKey) => {
    navigate(newActiveKey);
  };

  const remove = (targetKey) => {
    let newActiveKey = activeKey;
    const targetIndex = panes.findIndex(pane => pane.key === targetKey);
    const newPanes = panes.filter(pane => pane.key !== targetKey);

    if (newPanes.length && activeKey === targetKey) {
      newActiveKey = newPanes[targetIndex === newPanes.length ? targetIndex - 1 : targetIndex].key;
    } else if (newPanes.length === 0) {
      newActiveKey = '/dashboard';
    }

    if (activeKey !== newActiveKey) {
      navigate(newActiveKey);
    }
    setPanes(newPanes);
  };

  const onEdit = (targetKey, action) => {
    if (action === 'remove') {
      remove(targetKey);
    }
  };

  const handleRefresh = () => {
    setPanes(prevPanes =>
      prevPanes.map(pane =>
        pane.key === activeKey
          ? { ...pane, refreshKey: pane.refreshKey + 1 }
          : pane
      )
    );
  };

  const tabItems = useMemo(() => {
    return panes.map(pane => ({
      key: pane.key,
      label: pane.title,
      children: (
        <div style={{ background: '#fff', padding: 10 }} key={pane.refreshKey}>
          {pane.key === activeKey && pane.content}
        </div>
      ),
      closable: pane.closable,
    }));
  }, [panes, activeKey]);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider width={200} theme="dark">
        <div style={{ height: '32px', margin: '16px 0', color: '#fff', fontSize: '18px', textAlign: 'left', paddingLeft: '30px', lineHeight: '32px' }}>
          ERP 系统
        </div>
        <SidebarMenu />
      </Sider>
      <Layout className="site-layout">
        <Header style={{ padding: '0 24px', background: '#fff' }}>
          <div style={{ float: 'right' }}>
            <Space>
              <Avatar icon={<UserOutlined />} />
              <span>欢迎, {user?.email}</span>
              <Button type="link" onClick={logout}>退出登录</Button>
            </Space>
          </div>
        </Header>
        <Content style={{ margin: '16px', overflow: 'auto' }}>
          <Tabs
            hideAdd
            onChange={onChange}
            activeKey={activeKey}
            type="editable-card"
            onEdit={onEdit}
            style={{ height: '100%' }}
            size="small"
            tabBarExtraContent={
              <Button
                icon={<SyncOutlined />}
                onClick={handleRefresh}
                style={{ marginRight: '16px' }}
              >
                刷新
              </Button>
            }
            items={tabItems}
          />
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;